export const BRAND = 'EBOOKSTORE™';
export const PRODUCT_NAME = 'Mega Pack Instructor de Bomberos';
export const CHECKOUT_URL = 'https://mega-pack-instructor-de-bomberos.impultienda.ar/checkout';
export const OFFER_SECTION_ID = 'oferta';
export const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/81ryh36NdbGFXnErp25BZU/Mega_Pack_de_Capacitacion_Bomberil.png';
export const PRICE = '$19.990 ARS';
export const CONTACT_EMAIL = 'ebookstore028@gmail.com';

export const quickStats = [
  { value: '6', label: 'Volúmenes completos' },
  { value: '5', label: 'Bonos prácticos' },
  { value: '20', label: 'Clases listas para adaptar' },
  { value: '40', label: 'Escenarios de entrenamiento educativo' },
  { value: '150', label: 'Preguntas de evaluación' },
];

export const galleryImages = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/8Rjp8qJD9tQ8pMNEvmk2ti/Captura_de_pantalla_2026-10-13_200147.png',
    alt: 'Enseñar el tetraedro del fuego: ejemplo pedagógico completo',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/eqp5ZXmcu32GtY8QWqJf6m/Captura_de_pantalla_2026-10-13_200304.png',
    alt: 'Organización del espacio y el grupo: filas, semicírculo, mesas por grupos y discusión',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/tacHhJ1sbEFWAfPeXZLiMJ/Captura_de_pantalla_2026-10-13_200725.png',
    alt: 'Crear láminas e infografías educativas: clasificación conceptual de fuegos',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/7KwvyQB6nv6giXmr3wAeKs/Captura_de_pantalla_2026-10-13_201552.png',
    alt: 'Explicar claro no significa explicar menos: cómo explicar conceptos técnicos',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/epdSqLL3318NuosTQrAXdw/Captura_de_pantalla_2026-10-13_201619.png',
    alt: 'Distribución del tiempo en una clase de 60 minutos',
  },
];

export const withoutSystem = [
  'Buscar y organizar información para cada clase.',
  'Preparar actividades y evaluaciones desde cero.',
  'Crear recursos didácticos y planillas.',
  'Dedicar horas a planificar cada capacitación.',
  'Repetir el proceso semana tras semana.',
];

export const withSystem = [
  '6 volúmenes con contenidos organizados.',
  '20 clases listas para adaptar.',
  '40 escenarios educativos.',
  '150 preguntas de evaluación.',
  'Recursos visuales, planillas y planificación anual.',
];

export const faqs = [
  {
    q: '¿Necesito ser instructor certificado para utilizar el Mega Pack?',
    a: 'El material está dirigido a instructores, formadores y responsables de capacitación. Es un recurso educativo complementario y no reemplaza los requisitos institucionales para desempeñarse como instructor.',
  },
  {
    q: '¿Cómo recibo el material?',
    a: 'El producto es 100% digital. Una vez confirmada la compra, recibís acceso al contenido mediante el sistema de entrega de la tienda.',
  },
  {
    q: '¿Puedo adaptar las clases a mi institución?',
    a: 'Sí. Las planificaciones y actividades están pensadas para adaptarse a las necesidades educativas y los protocolos de cada institución.',
  },
  {
    q: '¿Incluye material práctico o solamente teoría?',
    a: 'Incluye ambos. Recibís contenidos técnicos, 20 clases desarrolladas, 40 escenarios educativos, evaluaciones, planillas y herramientas de planificación.',
  },
  {
    q: '¿Los 5 bonos están incluidos?',
    a: 'Sí. Con tu compra accedés a los 6 volúmenes principales y los 5 bonos prácticos.',
  },
  {
    q: '¿Es un pago único?',
    a: 'Sí. Realizás un único pago por todo el contenido digital incluido.',
  },
  {
    q: '¿El Mega Pack reemplaza la capacitación oficial?',
    a: 'No. Es una herramienta didáctica complementaria que no sustituye certificaciones oficiales, protocolos institucionales ni prácticas operativas supervisadas.',
  },
];

export const recentBuyers = [
  { name: 'Martín Gómez', city: 'Córdoba' },
  { name: 'Lucía Fernández', city: 'Rosario' },
  { name: 'Diego Romero', city: 'Mendoza' },
  { name: 'Carolina Sosa', city: 'La Plata' },
  { name: 'Federico Álvarez', city: 'San Miguel de Tucumán' },
  { name: 'Valeria Díaz', city: 'Mar del Plata' },
  { name: 'Javier Medina', city: 'Salta' },
  { name: 'Sebastián Molina', city: 'Neuquén' },
  { name: 'Lorena Torres', city: 'Santa Fe' },
  { name: 'Pablo Ruiz', city: 'Bahía Blanca' },
  { name: 'Gabriela Benítez', city: 'Posadas' },
  { name: 'Nicolás Herrera', city: 'Buenos Aires' },
  { name: 'Florencia Castro', city: 'Corrientes' },
  { name: 'Matías Acosta', city: 'San Juan' },
  { name: 'Natalia Aguirre', city: 'Resistencia' },
  { name: 'Hernán Giménez', city: 'Río Cuarto' },
];
